import { IUser } from "modules/app/types";

export const isLinkedInConnected = (user: IUser) =>
  user && user.linkedIn && !user.linkedIn.disconnected;

export const getLinkedInInfo = (user: IUser) =>
  isLinkedInConnected(user) ? user.linkedIn : undefined;
